import { GQLAvailablePromoServices } from 'generated-graphql/graphql'

export const SAVE_PROMO_SERVICE_AVAILABLE = 'SAVE_PROMO_SERVICE_AVAILABLE'

export type PromoServiceAvailableTypes = SavePromoServiceAvailable

interface SavePromoServiceAvailable {
  type: typeof SAVE_PROMO_SERVICE_AVAILABLE
  availablePromoServices: GQLAvailablePromoServices[]
}

export const savePromoServiceAvailableAction = (
  availablePromoServices: GQLAvailablePromoServices[]
) => ({
  type: SAVE_PROMO_SERVICE_AVAILABLE,
  availablePromoServices,
})
